import { useState } from 'react';
import api from '../services/api';
import { useToast } from '../components/Toast';

export interface KbImage { id: string; fileName: string; mimeType: string; fileSize: number; }

export function useKbImages(articleId: string | undefined) {
  const { toast } = useToast();
  const [uploading, setUploading] = useState(false);

  const upload = async (file: File): Promise<KbImage | null> => {
    if (!articleId) return null;
    setUploading(true);
    const form = new FormData();
    form.append('file', file);
    try {
      const res = await api.post(`/kb/${articleId}/images`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
      return res.data.image as KbImage;
    } catch (e: any) {
      toast(e?.response?.data?.error || 'Image upload failed', 'error');
      return null;
    } finally {
      setUploading(false);
    }
  };

  return { uploading, upload };
}
